<template>
<div class="ResetPasswordVerification">
    <v-container fill-height class="primary loginMain">
        <v-layout row wrap align-center>
          <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
            <div class="Formcard grey lighten-5 align no-shadow card-r">
              <v-form v-model="ResetPasswordVerification" row class="w-100">
                <v-flex xs12 md12 pt-0>

                    <v-toolbar flat xs12 class="transparent pa-0">
                            <div  class="btn-tool text-xs-right">
                            <a :href="`#/resetpassword`" class="aBtn"><v-icon class="textColor">keyboard_backspace</v-icon></a>
                            </div>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                            <h2 class="textColor text-xs-center title">Verificaton</h2>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items class="hidden-sm-and-down">
                            </v-toolbar-items>
                        </v-toolbar>
                </v-flex>
                    <!--<v-flex xs12 md12 pt-0 pb-5>-->
                        <!-- <img class = "logo" src="../../assets/logo.png"/>
                        <h1 class="headline font-weight-medium">Reset password</h1> -->

                    <!--</v-flex>-->
                            <v-layout wrap class="logBD">
                                <!-- <v-flex xs12 md12 class="text-xs-right" py-0 my-0>
                                </v-flex> -->
                                <v-flex xs12 sm12>
                                     <p class="text-xs-left caption font-weight-regulars" >Enter your Verification Code</p>
                                    <v-text-field
                                    solo
                                    label="Code"
                                      v-model="Code" :rules="emailRules" required></v-text-field>
                                </v-flex>

            <v-flex xs12 sm12 pb-0>
                <v-btn class="btnM primary card-r no-shadow" color="white" :disabled="!ResetPasswordVerification" :to="`/newpassword`">Confirm</v-btn>
            </v-flex>

        </v-layout>
    </v-form>
</div>
</v-flex>
</v-layout>
</v-container>

</div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ResetPasswordVerification",
  data: () => ({
    ResetPasswordVerification: false,
    Code: ""
  })
};
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/auth/ResetPasswordVerification.vue